module.exports = __webpack_public_path__ + "static/media/career.45590cfc.jpg";